import CommDialog from "./index.vue";

var obj = {};
obj.install = function (Vue) {
  const commDialog = function () {
    let instance = {};
    const commdlgConstructor = Vue.extend(CommDialog);
    const nodeObj = new commdlgConstructor();
    nodeObj.$mount(document.createElement("div"));
    document.body.appendChild(nodeObj.$el);

    instance.Options = function (options) {
      nodeObj.Options(options);
      return this;
    };

    instance.Open = function (onOk, onCancel, onClosed) {
      nodeObj.Open(onOk, onCancel, onClosed);
      return this;
    };

    instance.Confirm = function (title, description, onOk, onCancel, onClosed) {
      nodeObj.Confirm(title, description, onOk, onCancel, onClosed);
      return this;
    };

    instance.Input = function (
      title,
      description,
      width,
      attrs,
      onOk,
      onCancel,
      onClosed
    ) {
      nodeObj.SingleInput(
        title,
        description,
        width,
        attrs,
        onOk,
        onCancel,
        onClosed
      );
      return this;
    };


    instance.Component = function (comp) {
      nodeObj.AppendComponent(comp);
      return this;
    };



    return instance;
  };
  Vue.prototype.$commdlg = commDialog;
};
export default obj;
